import { useQuery } from "@tanstack/vue-query";
import { dashboardSummaryAdminQuery } from "@vendata/power-up-sdk/requests/admin/dashboard-summary";

export function useDashboardLoader() {
  return {
    dashboardSummaryQuery: useQuery(dashboardSummaryAdminQuery()),
  };
}
